<template>
  <div class="content new-profile">
    <div class="md-layout" @click="selectArea($event)">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <profile-steps />
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <div class="md-layout md-gutter md-alignment-center-center">
          <div class="searchResultWpr">
            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-left-sec">
              <span class="md-title profile-title">Company Report <try-beta-pill product="company_report" :data-id="dataId" /></span>
              <div>
                <p class="description">
                  Combine our data with a few simple inputs for a quick look into company performance. Results include a
                  comparison of company and industry KPIs, estimated value range, local market overview, and a highlight
                  of the company’s strengths and weaknesses.
                </p>
                <ul class="profile_details">
                  <li v-if="industry">
                    <div>
                      <p class="h3-p">{{ industry }}</p>
                        <p class="h6-p">Industry</p>
                    </div>
                  </li>
                  <li v-if="marketArea">
                    <div>
                      <p class="h3-p">{{ marketArea.split('[')[0] }}</p>
                        <p class="h6-p">Market Area</p>
                    </div>
                  </li>
                  <li v-if="salesClass">
                    <div>
                      <p class="h3-p">{{ salesClass.split('[')[0] }}</p>
                        <p class="h6-p">Sales Class</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-right-sec">
              <PulseLoader :loading="loading" :class="{ hide: !loading }"></PulseLoader>
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100 fin-pro-card no_padding">
                  <profile-card class="toolbar-card">
                    <template slot="header">
                      <div class="toolbar-card-title">
                        <p class="title text-left h5-p">{{ countLabel }}</p>
                      </div>
                    </template>
                    <template slot="content">
                      <div class="info-wrap">{{ operations }}</div>
                    </template>
                  </profile-card>
                </div>
                <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100">
                  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                    <template>
                      <!-- <router-link
                        :to="{
                          name: 'Competitors',
                          params: { id: this.profileId },
                        }"
                      >-->
                      <md-button v-if="isAccessible" @click.native="confirmationModal = true" :disabled="isDisabled"
                        class="md-info md-block access-button">
                        <span>Access Now</span>
                      </md-button>
                      <md-button v-else @click.native="access" :disabled="isDisabled"
                        class="md-info md-block access-button">

                        <span>Add To Cart</span>
                      </md-button>
                      <!-- </router-link> -->
                    </template>
                    <div class="alert md-layout-item" v-if="notAvailable">
                      <span class="closebtn" @click="closeAlert">&times;</span>
                      Sorry, we do not have enough data available for this
                      selection. Please try again.
                    </div>
                    <!-- <pulse-loader :color="'blue'" :loading="loading">
                    </pulse-loader>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 fin-tab-list d-none">
        <nav-tabs-card no-label md-elevation="0">
          <template slot="content">
            <md-tabs md-alignment="left" id="financialProfileTabs">
              <industry-tab />
              <market-area-tab />
              <!-- <related-products-tab /> -->
            </md-tabs>
          </template>
        </nav-tabs-card>
      </div>
    </div>
    <div class="prospect_content">
      <modal v-if="confirmationModal" @close="confirmationModal = false">
        <template slot="header">
          <button type="button" class="close_btn" @click="confirmationModal = false">
            <md-icon>clear</md-icon>
          </button>
        </template>
        <template slot="body">
          <div class="field_wpr">
            <h4 class="modal-title">
              Please confirm access to this product with the selected parameters.
              Click Review to review the parameters or Access Now to access this product.
            </h4>
            <div class="ml-4 md-layout">
              <md-button @click="confirmationModal = false"
                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">Review</md-button>
              <md-button @click="access" class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">Access
                Now</md-button>
            </div>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Modal, ProfileCard, NavTabsCard, PulseLoader } from '@/components';
import IndustryTab from './_company_partials/IndustryTab';
import MarketAreaTab from './_company_partials/MarketAreaTab';
// import RelatedProductsTab from './_partials/RelatedProductsTab';
import ProfileSteps from './_company_partials/ProfileSteps.vue';
import TryBetaPill from './SelectorBeta/TryBetaPill.vue';
import { trackSelectorViewed, trackSelectorCompleted } from './SelectorBeta/analytics';
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  name: 'new-company-report',
  components: {
    ProfileCard,
    NavTabsCard,
    IndustryTab,
    MarketAreaTab,
    // RelatedProductsTab,
    ProfileSteps,
    TryBetaPill,
    PulseLoader,
    Modal,
  },
  data() {
    return {
      confirmationModal: false,
      isDisabled: true,
      operations: '',
      countLabel: 'Firms',
      loading: false,
      myData: null,
      years: null,
      createDataCompanyReport: this.companyData,
      isAccessible: true,
      notAvailable: false,
    };
  },
  props: ['dataId', 'companyData', 'isCSV', 'file'],
  methods: {
    ...mapActions({
      updatePullTime: "tracking/updatePullTime",
    }),
    closeAlert: function () {
      this.notAvailable = false;
    },
    selectArea: function (e) {
      let parentDiv = document.querySelectorAll('.custom-step-pro');
      let deactiveClass = document.querySelectorAll('.step-progress__step');
      let favoriteDropdown = document.querySelectorAll('.favourite_list');
      deactiveClass.forEach(function (el) {
        el.classList.remove('open');
      });
      favoriteDropdown.forEach(function (el) {
        el.classList.remove('open');
      });
      parentDiv.forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    access: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/create/companyReport',
          {},
          {
            params: {
              session_id: currentSession,
              industry: this.getData(this.industry),
              sales_class: this.getData(this.salesClass),
              area: this.getData(this.marketArea),
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              zips: this.marketArea && this.marketArea.includes('zips') ? this.marketArea.split('[')[0].replace('+','') : null, 
              type: 'company',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/products/access" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          // const { access, location } = res.data;
          let id = res.data.id;
          this.updatePullTime({ isFinishedDate: false, productId: id });
          this.$store.commit('C_SET_PROFILE_ID', id);

          if (this.dataId) {
            this.createDataCompanyReport.profile_id = id;
            this.addCompanyReport()
          } else {
            let params = {
              product_id: id,
            };

            this.$store.dispatch('cart/accessProduct', params).then((res) => {
              if (res.cart) {
                this.$router.push({
                  name: 'Cart',
                  params: { id: id },
                });
              }

              if (res.access || (res.error && res.errorCode === 'product_already_accessed')) {
                trackSelectorCompleted('company_report', 'classic');
                this.$router.push({
                  name: 'CRAbouttheData',
                  params: { id: id },
                });
              }
            });
          }
        });
    },
    checkAccessByType: async function () {
      if (this.subscriptions.includes('swot'))
        this.isAccessible = true;
      else
        this.isAccessible = false;
    },
    addCompanyReport: async function () {
      if (this.isCSV) {
        this.createDataCompanyReport.csv_data_file = this.file;
        this.createDataCompanyReport.submit_csv = true;
      }
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/report/save',
          {},
          {
            params: this.createDataCompanyReport,
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/report/save" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.$store.dispatch('alerts/success', 'Inputs applied.');

          let params = {
            product_id: this.createDataCompanyReport.profile_id,
          };

          this.$store.dispatch('cart/accessProduct', params).then((res) => {
            if (res.cart) {
              this.$router.push({
                name: 'Cart',
                params: { id: this.createDataCompanyReport.profile_id },
              });
            }

            if (res.access || (res.error && res.errorCode === 'product_already_accessed')) {
              this.$router.push({
                path: `/company-report/${this.createDataCompanyReport.profile_id}/report-about-the-data`,
              });
            }
          });
        });
    },

    clearAll: async function () {
      this.$store.commit('C_SET_PROFILE_ID', null);
      this.$store.commit('SET_PROFILE_ID', null);
      this.$store.commit('C_SET_INDUSTRY', null);
      this.$store.commit('C_SET_MARKET_AREA', null);
      this.$store.commit('C_SET_SALES_CLASS', null);
    },
    checkAvailability: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      if (this.industry != null && this.marketArea != null && this.salesClass != null) {
        this.operations = '';
        this.isDisabled = true;
        this.loading = true;

        // The Company Report benchmarks against industry-financial (IF) data at
        // the SELECTED sales class, so the count shown here should be the
        // sales-class-aware IF firm count (it changes with the sales class) —
        // not the market 'Operations' establishment count, which is industry+
        // area only and so never varied by sales class (reported bug). IF covers
        // US / state / metro; for ZIP (and anything IF can't count for this
        // selection) fall back to the market count below.
        if (!this.marketArea.includes('zips')) {
          let firms = null;
          try {
            const ifRes = await axios.get(process.env.VUE_APP_API_BASE_URL + '/info/IF_available', {
              params: {
                industry: this.getData(this.industry),
                area: this.getData(this.marketArea),
                sales_class: this.getData(this.salesClass),
              },
            });
            const d = ifRes.data && !ifRes.data.error ? ifRes.data.data : null;
            if (d && d !== 0 && d !== -1 && d.firms) firms = d.firms;
          } catch (e) {
            firms = null;
          }
          if (firms) {
            this.operations = firms;
            this.countLabel = 'Firms';
            this.isDisabled = false;
            this.notAvailable = false;
            this.loading = false;
            return;
          }
        }

        // Fallback: market 'Operations' establishment count (ZIP areas, or where
        // IF has no sales-class count for this selection).
        this.countLabel = 'Operations';
        let resZips = '0';
        let resArea = 0;
        let resMap_center = '0';
        let resMap_center_zip = '0';
        let resRadius = '0';
        await axios
          .get(process.env.VUE_APP_API_BASE_URL + '/info/IMR_available', {
            params: {
              industry: this.getData(this.industry),
              area: this.getData(this.marketArea),
              zips: this.marketArea.includes('zips') ? this.marketArea.split('[')[0] : null,
              map_center: resMap_center,
              map_center_zip: resMap_center_zip,
              radius: resRadius,
              sales_class: this.getData(this.salesClass),
            },
          })
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IMR_available" <br>`
              );
              throw new Error(
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
              );
            }
            const { data } = res.data;
            if (data != 0) {
              this.operations = data[0];

              if (this.salesClass && this.marketArea && this.industry) {
                this.isDisabled = false;
              }

              this.loading = false;
              this.notAvailable = false;
            } else {
              this.operations = '';
              this.isDisabled = true;
              this.loading = false;
                this.notAvailable = true;
            }
          });
      } else {
        this.isDisabled = true;
        this.operations = '';
      }
    },
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
      subscriptions: (state) => state.user.user_subscriptions ?? null,
    }),
    industry() {
      return this.$store.getters.cIndustry;
    },
    marketArea() {
      return this.$store.getters.cMarketArea;
    },
    salesClass() {
      return this.$store.getters.cSalesClass;
    },
    profileId() {
      return this.$store.getters.cProfileId;
    },
  },
  watch: {
    industry(newValue, oldValue) {
       this.notAvailable = false;
      this.checkAvailability();
    },
    marketArea(newValue, oldValue) {
       this.notAvailable = false;
      this.checkAvailability();
    },
    salesClass(newValue, oldValue) {
       this.notAvailable = false;
      this.checkAvailability();
    },
    subscriptions() {
      if (this.subscriptions && this.subscriptions.length > 0)
        this.checkAccessByType()
    }
  },
  mounted() {
    trackSelectorViewed('company_report', 'classic');
  },
  async created() {
    await this.clearAll();
  },
};
</script>
<style lang="scss">
.new-profile {
  margin-top: 20px;
  padding-top: 30px;
}

.profile-left-sec {
  padding: 10px;
  padding-left: 30px !important;
}

@media only screen and (max-width: 600px) {
  .fin-pro-card {
    margin-bottom: 10px;
  }

  .profile-left-sec {
    margin-bottom: 10px;
  }

  .fin-tab-list {
    margin-top: 350px;
  }

  #finantialProfileTabs .md-tabs-navigation {
    padding-left: 15px;
  }
}

@media screen and (max-width: 1280px) and (min-width: 600px) {
  .fin-tab-list {
    margin-top: 150px;
  }
}
